export default __webpack_public_path__ + "static/media/digital.09ea1843.jpeg";